/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;

var debugMode = false;


/**
 * DOM ready
 */
$(function() {
    /**
     * Delay per resize della larghezza della finestra.
     * Converte eventi multipli di resize in uno solo.
     */
    var resizeTimeout;
    $(window).data("current-width", $(window).width()).on("resize", function() {

        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(function() {

            // se è variata la larghezza lancio evento
            if ($(window).width() != $(window).data("current-width")) {

                $(window).data("current-width", $(window).width());

                // evento custom ad uso di altre funzioni
                $(window).trigger("width_resize");

                updateSwiper();

            }

        }, 500);
    });
});


/**
 * Load
 */
$(window).on("load", function() {

    
    

    
        /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
         $(document).on("loadermanager-page_loaded", function() {
            
            // init barba.js
            barbaInit();
     
            //inizializzo locomotive scroll
            locomotiveInit();
    
            // rimozione loader
            setTimeout(function() {
                pageEnter();
                $('body').removeClass('loading');
            }, 200);
            
            //icona che segue il mouse
            initSeguiMouse();

            //ancore interne 
            updateAnchors();
    
            //gestione del back del browser (con modal aperto viene disabilitato)
            gestioneBack();

        });


    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");

    /**
     * Init di lazysizes
     */
     document.addEventListener('lazyloaded', function(e){
        e.target.classList.remove('loading');
    });
    lazySizes.init();

});



/**
 * init locomotive scroll
 */
 var scrollPos = 0;

 let scroll;

 
 function locomotiveInit() {
 
    
     let options = {
 
         el: document.querySelector('[data-scroll-container]'),
         smooth: true,
         getSpeed: true,
         getDirection: true,
         
         smartphone: {
            smooth: false
        },

        tablet: {
            smooth: false
        },
         reloadOnContextChange: true,
         firefoxMultiplier: 70,
         resetNativeScroll: true
     }
 
    var direction;
    var oldHeight = 0;
    var contentHeight;
    var scrollTimeout;
    var oldScrollPos;

     scroll = new LocomotiveScroll(options);
 
     scroll.on('scroll', (instance) => {
        
        
         


        direction = instance.direction;
        scrollPos = instance.scroll.y;

        //gestione dell'header 
        var diff = Math.round(Math.abs((Math.abs(scrollPos) - Math.abs(oldScrollPos))) );
        if(scrollPos < 250){
            //in cima alla pagina, viene visualizzato
            $('body').removeClass('scrolling');
            $('body').removeClass('scrollingUp');
        } else if (direction == "down" && diff > 3) {
            //se si scrolla verso il basso, viene nascosto
            $('body').addClass('scrolling');
            $('body').removeClass('scrollingUp');
        } else if (direction == "up" && diff > 5){
            //se si scrolla verso l'alto viene ri-visualizzato 
            $('body').removeClass('scrolling');
            $('body').addClass('scrollingUp');
        }
        oldScrollPos = scrollPos;
        



        //  //cambio stato all'header
        //  if (scrollPos > 55) {
        //      $('body').addClass('scrolling');
        //  } else {
        //      $('body').removeClass('scrolling');
        //  }

         //direction = instance.direction;
        
    
        
        //accrocchio per evitare calcolo sbagliato dell'altezza della pagina
        clearTimeout(scrollTimeout);

         scrollTimeout = setTimeout(function() { 
            contentHeight = Math.round($('.contents').height());
            //se l'altezza dei contenuti differisce più di 10px aggiorno lo scroll
            if(Math.abs((Math.abs(contentHeight) - Math.abs(oldHeight)))>10 ){
                if(debugMode){console.log('altezza diversa - update scroll ----------------')}
                oldHeight = contentHeight;
                scroll.update();
            }            

         }, 50);


        


     })


     setTimeout(() => {
        scroll.on('call', (value, way, obj) => {
                if(debugMode){
                    console.log(way + " | " + obj.id + " | " + direction + " | >>>>" + value);
                }
                if (way === 'enter') {
                    switch (value) {

                        case "header-negative":                        
                            $('body').addClass('negative');
                        break;

                        
                        /* solo su pagina collezione 
                        case "collection-positive":
                            $('body').removeClass('negative');           
                        break;

                        case "collection-negative":
                            $('body').addClass('negative');           
                        break;
                        */
                        /*
                        case "pageColor":
                        // cambio colore al body (letto da  data-scroll-id )
                        document.querySelector('body').style.backgroundColor = obj.id;
                        break;
                        */
                         
                    }
                }
                if(way === 'exit'){
                    switch (value) {
                    case "header-negative":
                        
                        $('body').removeClass('negative');
                        
                        break;
                   
                    }
                }

        });
      }, 800);
 
     //aggiorno lo scroll 
     setTimeout(function() {
         scroll.update();
     }, 200);
 
     // memorizzo per accesso in altri punti
     window.locoScroll = scroll;
 
     // ad uso di altri script
     $(document).trigger("locomotive-init");
 
 }



/**
 * Funzione di uscita pagina
 */
function pageExit(callback)
{   
   if(debugMode){console.log("-----page EXIT")}
      // porto in primo piano prima di iniziare animazione
      $("#page_loader").css({
        zIndex: 100 // sotto all'header!
    });
    
    //animazione in uscita dalla pagina (il loader entra)     
   $( "#page_loader" ).animate({opacity:1}, 500, function() {
       // Animation complete
       if (callback && typeof(callback) == 'function') {
           callback();
       }
   });

}



/**
 * Funzione di entrata pagina
 */
function pageEnter(callback)
{

    
    setTimeout(function() { //aggiunto timeout per problemi di selezione elementi jquery


        //swiper orizzontale in griglia (lista projects, lista plus)
        initGridSwiper();


        //modal materiali
        if($('.modal').length){
            UIkit.util.on('.modal', 'show', function () {
                //quando il modal viene aperto, disabilito il back del browser 
                modalVisible = true;
            });
            UIkit.util.on('.modal', 'hide', function () {
                modalVisible = false;
            });
        }


        //rimuovo il bg color della pagina precedente
        $('body').removeAttr('style');
        
        //gestione dell'header in prima battuta (negativo o positivo) poi verrà cambiato dalle section in pagina
        if($('.contents').attr('data-header') == 'negative'){
            $('body').addClass('negative');
        } else {
            $('body').removeClass('negative');
        }
        
       
       
        



    }, 50);



    //animazione in entrata della pagina (uscita del loader)
    $( "#page_loader" ).animate({opacity: "0"}, 1000, function() {

        // Animation complete
        
        // porto sotto per poter interagire con pagina
        $("#page_loader").css({
            zIndex: -1,
            //height:'100%',
            //top:'100%',
            //opacity:1
        });
        if (callback && typeof(callback) == 'function') {
            callback();
        }
        
    })


    //aggiorno locomotive scroll
    setTimeout(function() {
        scroll.update();

        //aggiorno le ancore in pagina
        updateAnchors();

    }, 300);

}


/**
 * Gestione caricamento asincrono
 */
function barbaInit()
{
   
    // controllo disponibilità barba
    if(typeof(barba) === "undefined") {
        return console.log("barba non disponibile");
    }

    barba.init({
        timeout: 10000,
        transitions: [{
            name: 'default-transition',
            beforeLeave(data) {
             
                // attendi finchè loader entra prima di lasciare la pagina
                const done = this.async();

                
                // qui posso fare altre cose.....
                return pageExit(function() {
                    return done();
                });
                                 

            },
            leave(data) {

               //scrollo in cima               
               scroll.scrollTo(0, {duration:0, disableLerp:true});
               
               setTimeout(function() {
                   //tolgo la classe scrolling
                   $('body').removeClass('scrolling');
                   $('header').removeClass('menuOpen');
               }, 200);


            },
            afterLeave(data) {
               
               //rimuovo tutte le classi della pagina precedente
               $("body").removeClass (function (index, className) {
                   return (className.match (/(^|\s)page-\S+/g) || []).join(' ');
               });
               
            },
            beforeEnter(data) {
               
               
            },
            enter(data) {
                                
            },
            afterEnter(data) {

                //aggiorno icona che segue il mouse
                updateSeguiMouse();

                
               
                // tracciamento analytics
                if(typeof(gtag) == 'function' && typeof(GA_MEASUREMENT_ID) != 'undefined') {
                    gtag('config', GA_MEASUREMENT_ID, {'page_path': window.location.pathname});
                }
                
               updateDom(data, function() {
                   

                   pageEnter();

                   
               });

            }
        }],
        views: [
            {
               
                //HOMEPAGE
                namespace : 'homepage',
                afterEnter(data) {
                     
                }
            },
            {
                //Collezione
                namespace : 'collezione',
                afterEnter(data) {

                    initCataloghiSwiper();
                    
                    

                }
            }

        ],
        requestError: (trigger, action, url, response) => {
            
            // forzo a seguire le url 404 per visione del messaggio
            if(action == 'click' && response.status == 404) {
                window.location.href = url;
                return false;
            }


        },
        preventRunning : true
    });
}

function updateSwiper(){
    initGridSwiper();
    initCataloghiSwiper();
}

function initGridSwiper(){
    if($('.gridSwiper').length){
        var swiper = new Swiper(".gridSwiper", {
            
            pagination: {
              el: ".pagination",
              type:'fraction'
            },
            navigation: {                    
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                320: {
                  slidesPerView: 1.2,
                  spaceBetween: 13,
                  grid: {
                    rows: 1,
                  },
                },
                768: {
                  slidesPerView: 2.2,
                  spaceBetween: 20,
                  grid: {
                    rows: 2,
                  },
                },                            
                1400: {
                    slidesPerView: 2.5,
                    spaceBetween: 23,
                    grid: {
                      rows: 2,
                    },
                },
                1800: {
                    slidesPerView: 3.5,
                    spaceBetween: 23,
                    grid: {
                      rows: 2,
                    },
                }
            }
          });
    }
}

function initCataloghiSwiper(){
    if($('.gridSwiper').length){
        var swiper = new Swiper(".cataloghiSwiper", {
            slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {    
                    return '<span class="' + className + '">' + $('.cataloghiSwiper .swiper-slide:nth-child('+ (index + 1) +')').attr('data-txt') + "</span>";
                },
            },
        });
    }
}


var cursor;
var cursorImg;
function initSeguiMouse(){
    if($('html').hasClass('no-touch')){
        //rollover con icona che segue il cursore 
        cursor = $(".myCursor");
        cursorImg = $(".myCursor img");

        var $mouseX = 0, 
            $mouseY = 0;
        var $xp = 0, 
            $yp =0;
        
        $(document).on("mousemove", function(e) {
            $mouseX = e.pageX+25;
            $mouseY = e.pageY+25; 
        });
        
        var $loop = setInterval(function(){
            $xp += (($mouseX - $xp)/5);
            $yp += (($mouseY - $yp)/5);
            cursor.css({left:$xp +'px', top:$yp +'px'}); 
        }, 30);

        
        var $loop2 = setInterval(function(){
            //zoom su materiali
            var t = cursorImg.attr('data-t');
            if(t){
                var l = cursorImg.attr('data-l');
                var cursorImgL = -(($mouseX-25) - l);
                var cursorImgT = -(($mouseY-25) - t);
                cursorImg.css({left:cursorImgL +'px', top:cursorImgT +'px'}); 
            }
        }, 1);

        updateSeguiMouse();

    }
}
function updateSeguiMouse(){
    

    if($('html').hasClass('no-touch')){
        
        $(".hover-scroll").on("mouseenter", function() {
            cursor.addClass("scroll");
            if($(this).hasClass("invert")){
                cursor.addClass("invert");
            }
        });
        $(".hover-scroll").on("mouseleave", function() {
            cursor.removeClass("scroll");
            cursor.removeClass("invert");
        });
        
        $(".hover-next").on("mouseenter", function() {
            cursor.addClass("next");
            if($(this).hasClass("invert")){
                cursor.addClass("invert");
            }
        });
        $(".hover-next").on("mouseleave", function() {
            cursor.removeClass("next");
            cursor.removeClass("invert");
        });

        $(".hover-prev").on("mouseenter", function() {
            cursor.addClass("prev");
            if($(this).hasClass("invert")){
                cursor.addClass("invert");
            }
        });
        $(".hover-prev").on("mouseleave", function() {
            cursor.removeClass("prev");
            cursor.removeClass("invert");
        });

        $(".hover-down").on("mouseenter", function() {
            cursor.addClass("down");
            if($(this).hasClass("invert")){
                cursor.addClass("invert");
            }
        });
        $(".hover-down").on("mouseleave", function() {
            cursor.removeClass("down");
            cursor.removeClass("invert");
        });

        $(".hover-plus").on("mouseenter", function() {
            cursor.addClass("plus");
            if($(this).hasClass("invert")){
                cursor.addClass("invert");
            }
        });
        $(".hover-plus").on("mouseleave", function() {
            cursor.removeClass("plus");
            cursor.removeClass("invert");
        });

        //hover zoom
        $(".hover-zoom").on("mouseenter", function() {
            cursor.addClass("zoom");

            var img = $(this).attr("href");
            cursorImg.attr('src', img);

            var rect = this.getBoundingClientRect();
            cursorImg.attr('data-t', rect.top);
            cursorImg.attr('data-l', rect.left);
            // cursorImg.attr('data-r', rect.right);
            // cursorImg.attr('data-b', rect.bottom);
        });
        $(".hover-zoom").on("mouseleave", function() {
            cursor.removeClass("zoom");
        });

    }
}

function updateAnchors(){
    //sostituisce le ancore in pagina con funzione locomotiveScroll
    $( 'a.anchor' ).each(function( index ) {

        $(this).on('click', function(event){ 
            var anchor = $( this ).attr( 'href' );
            var myOffset = $( this ).attr( 'data-offset' );
            
            if(myOffset == null){
                myOffset = -50;
            }
            if(anchor != '' && anchor.startsWith( '#')){
                //event.preventDefault();
                scroll.scrollTo(anchor, {duration:1000, offset:myOffset});
            }
        })
    });

    
}


var modalVisible;

function gestioneBack(){
    //gestione del back del browser quando vengono aperti i modal o lightbox materiali
    window.onpopstate = function () {
        if (modalVisible){
            //disabilito il back del browser
            window.history.go(1);
            //chiudo i modal
            if($('.modal').length){
                $('.modal').each(function( ) {
                    UIkit.modal(this).hide();
                });
            }
            //e chiudo i lightbox
            $('.lightbox').each(function( ) {
                $('.uk-lightbox-toolbar-icon.uk-close').click();
            });
        } 
    };

}

/**
 * Aggiorna il dom.
 * Sono possibili diverse strategie (combinarle a bisogno):
 * 1. sostituire in toto l'head (questo scatena anche anche esecuzione degli script, anche inline)
 * 2. sostituire tag specifici nell'head
 * 3. - inserire script/style specifici per la nuova pagina nel container di quest'ultima.
 *    - caricare gli script in ajax, mentre eventuali tag <style> presenti nel container verranno automaticamente valutati dal browser
 * 
 * Con gli stessi sistemi si possono aggiornare elementi al di fuori del container di barba
 */
function updateDom(data, callback) {

    var html = data.next.html;
    var newHeadHtml = html.match( /<head[\s\S]*?>[\s\S]*?<\/head>/gi )[0];

    // true mantiente gli script
    var $newPageHead = $.parseHTML(newHeadHtml, document, true);


    /**
     * Aggiorno namespace di body 
     */
    $("body").attr("data-namespace", data.next.namespace);


    /**
     * Aggiorno elemento attivo menu principale
     */
    //$("#page_header-mainmenu .uk-active").removeClass("uk-active");
    //$('#page_header-mainmenu [data-namespace="'+data.next.namespace+'"]').addClass("uk-active");
    
    
    /**
     * aggiorno html altri elementi
     * In ogni elemento dell'array inserire:
     * - o il selettore completo
     * - o il selettore + l'attributo che si vuole rimpiazzare
     */
    [
        'head',
        '#page_header-mainmenu',
        ['#page_header .logo a', 'href'],
        '#page_footer .info_menu',
		'.col-languages',
    ].forEach((selector) => {

        let realSelector = Array.isArray(selector) ? selector[0] : selector;
        let attribute = Array.isArray(selector) ? selector[1] : null;

        // recupero elemento nel nuovo html in arrivo
        let el = $(realSelector, $(data.next.html));

        // no lambda qui!
        $(realSelector).each(function() {
            if(attribute !== null) {
                // rimpiazzo attributo
                $(this).attr(attribute, el.attr(attribute));
            } else {
                // rimpiazzo contenuto html nella pagina
                $(this).html(el.html());
            }
        });

    });


    /**
     * 1. aggiornamento in toto dell'head
     */
    //$("head").html(newHeadHtml);

    
    /**
     * 2. aggiornamento di script specifici nell'head
     */
    $newPageHead = $( '<head />' ).html($newPageHead);
    var headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']",
        "link[rel='alternate']"
    ].join( ',' );
    
    $( 'head' ).find( headTags ).remove();
    
    $newPageHead.find( headTags ).appendTo( 'head' );
    /**
     * 2. // fine
     */


    /**
     * 3. Caricamento degli script presenti nel container della nuova pagina
     */
    $(data.next.container).find('script').each(function (i, script) {
        var $script = $(script);

        // script linkato
        if($script.attr('src')) {
            $.getScript($script.attr('src'));
        // script inline
        } else {
            $script.appendTo('[data-barba="container"]');
        }
        
    });
    /**
     * 3. // fine
     */

    if(callback && typeof(callback) == 'function') {
        return callback();
    }

    return true;
    
}